import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";
import cartConfig from "emun.cart/cart.config";
import AutoQuery from "servicestack/auto-query/auto-query";
import orderConfig from "emun.order/order.config";

export default class BackorderLinesPromptController {
	constructor(options, utils) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.bus = new ServiceBus();
		$ctrl.config = cartConfig;
		$ctrl.orderConfig = orderConfig;
		$ctrl.utils = utils;
		$ctrl.orderId = options.id;
		$ctrl.mode = options.mode;
		$ctrl.title = options.title;
		$ctrl.reverseSort = false;
		$ctrl.bus = new ServiceBus();
		$ctrl.title = "Pending Changes";
		$ctrl.loadCart();
	}

	loadCart() {
		const $ctrl = this;
		$ctrl.bus.send("QueryCarts.json?Id=" + $ctrl.orderId).then(function (res) {
			if (res.data.results.length > 0) {
				$ctrl.order = res.data.results[0];
			}
		});
	}

	approveChange(id) {
		const $ctrl = this;
		$ctrl.bus.send('ApproveChangeRequest.json', {
			CartId: $ctrl.orderId,
			Id: id
		}).then(function (res) {
			$ctrl.loadCart();;
		});
	}
	declineChange(id) {
		const $ctrl = this;
		$ctrl.bus.send('DeclineChangeRequest.json', {
			CartId: $ctrl.orderId,
			Id: id
		}).then(function (res) {
			$ctrl.loadCart();;
		});
	}
}
